var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0C0.984375 0 0 1.03125 0 2.25V17.25C0 18.5156 0.984375 19.5 2.25 19.5H3C3 21.9844 5.01562 24 7.5 24C9.98438 24 12 21.9844 12 19.5H18C18 21.9844 20.0156 24 22.5 24C24.9844 24 27 21.9844 27 19.5H28.5C29.2969 19.5 30 18.8438 30 18C30 17.2031 29.2969 16.5 28.5 16.5V13.5V12V11.1562C28.5 10.3594 28.1719 9.5625 27.6094 9L24 5.39062C23.4375 4.82812 22.6406 4.5 21.8438 4.5H19.5V2.25C19.5 1.03125 18.4688 0 17.25 0H2.25ZM19.5 7.5H21.8438L25.5 11.1562V12H19.5V7.5ZM9.75 19.5C9.75 20.7656 8.71875 21.75 7.5 21.75C6.23438 21.75 5.25 20.7656 5.25 19.5C5.25 18.2812 6.23438 17.25 7.5 17.25C8.71875 17.25 9.75 18.2812 9.75 19.5ZM22.5 21.75C21.2344 21.75 20.25 20.7656 20.25 19.5C20.25 18.2812 21.2344 17.25 22.5 17.25C23.7188 17.25 24.75 18.2812 24.75 19.5C24.75 20.7656 23.7188 21.75 22.5 21.75Z",
    fill: "#C49876"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTruck);
export default __webpack_public_path__ + "static/media/icon-truck.0146231d5172127bdcd6bba532cad941.svg";
export { ForwardRef as ReactComponent };